"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.ends-with.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

require("@mpxjs/webpack-plugin/lib/runtime/base.styl");

var _vue = require("vue");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require("vue-router");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _core = require("@mpxjs/core");

var _core2 = _interopRequireDefault(_core);

var _apiProxy = require("@mpxjs/api-proxy");

var _apiProxy2 = _interopRequireDefault(_apiProxy);

var _mpxFetch = require("@didi/mpx-fetch");

var _mpxFetch2 = _interopRequireDefault(_mpxFetch);

var _webxJs = require("@didi/webx-js");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/views/index/app.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

//
//
//
//
//
//
//
//
//
//
_vue2.default.use(_vueRouter2.default);

global.getApp = function func_trir_c1580a7f16c2adf6ff1749b180cd1b1b() {
};

global.getCurrentPages = function func_trir_11536a9248bde7369c1f0bf2cf79e113() {
    try {
        if (!global.__mpxRouter)
            return [];
        return global.__mpxRouter.stack.map(function func_trir_9bed30f731297dc7c6f1744f179eea9b(item) {
            try {
                var page;
                var vnode = item.vnode;
                if (vnode && vnode.componentInstance) {
                    page = vnode.tag.endsWith('mpx-tab-bar-container') ? vnode.componentInstance.$refs.tabBarPage : vnode.componentInstance;
                }
                return page || { route: item.path.slice(1) };
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_9bed30f731297dc7c6f1744f179eea9b@@../../../../src/views/index/app.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_11536a9248bde7369c1f0bf2cf79e113@@../../../../src/views/index/app.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};

global.__networkTimeout = undefined;
global.__mpxGenericsMap = {};
global.__style = "v1";
global.__mpxPageConfig = undefined;
var wxsModules = {};
global.currentSrcMode = "wx";

(0, _webxJs.initSDK)({
  branch: 'passenger'
});
/* passenger内设置 setLoginConfig */

/* 其他环境默认不使用passport获取登录信息 减少关于passport静态资源的加载 */

if (!__isServerRender__) {
  var _window$__INITIAL_STA;

  // 静态资源加载情况埋点上报
  window.PerfTrack.jsReady();

  if ((0, _webxJs.xenv)() === 'passenger' || (0, _webxJs.xenv)() === 'hitchapp') {
    var loginConfig = {
      loginType: 'trinity',
      productType: 'didi',
      useOauthCode: true
    };
    (0, _webxJs.canIUse)('setLoginConfig') && (0, _webxJs.setLoginConfig)(loginConfig);
  }

  if ((_window$__INITIAL_STA = window.__INITIAL_STATE__) !== null && _window$__INITIAL_STA !== void 0 && _window$__INITIAL_STA.prefetched) {
    window.PerfTrack.requestBegin();
    window.PerfTrack.responseReady(); // 性能埋点：SSR DOM 渲染完成

    window.PerfTrack.domReady({
      isKey: true
    });
  }
}

_core2.default.use(_apiProxy2.default, {
  usePromise: true
}).use(_mpxFetch2.default);
_core2.default.config.el = '.app';
var csrHost = ['page-test.intra.xiaojukeji.com', 'pre-page.udache.com', 'page.udache.com', '10.190.7.204:8080', '172.24.220.206:8081', '172.24.212.232:8080'];

if (__isServerRender__ || !csrHost.includes(window.location.host)) {
  _core2.default.config.webRouteConfig = {
    mode: 'history',
    base: '/wyc-channel-gift/'
  };
} // app.js


(0, _core.createApp)({});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "app", "index", "", {}, // @ts-ignore
{
  'index': function index() {
    try {
        return import('./index.mpx?async=true&isFirst=true&page=true').then(function func_trir_cb52d00fda76d0abe30316ef67284603(res) {
            try {
                return (0, _optionProcessor.getComponent)(res, { __mpxPageRoute: 'index' });
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_cb52d00fda76d0abe30316ef67284603@@../../../../src/views/index/app.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('index@@../../../../src/views/index/app.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  'test': (0, _optionProcessor.getComponent)(require("./test.mpx?page=true"), {
    __mpxPageRoute: "test"
  })
}, // @ts-ignore
{
  'mpx-keep-alive': (0, _optionProcessor.getComponent)(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-keep-alive.vue?component=true"), {
    __mpxBuiltIn: true
  })
}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules), _vue2.default, _vueRouter2.default);